import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const DHAKA_TZ = 'Asia/Dhaka';
dayjs.tz.setDefault(DHAKA_TZ);

const BDT_FORMATTER = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'BDT',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/**
 * Format a BDT amount with the ৳ symbol and `en-IN`-style grouping (which
 * matches Bangladeshi accounting convention more closely than `en-US`).
 */
export function formatBDT(amount: number | string): string {
  const n = typeof amount === 'string' ? Number.parseFloat(amount) : amount;
  if (Number.isNaN(n)) return '—';
  return BDT_FORMATTER.format(n);
}

export function formatDate(iso: string | Date, fmt = 'DD MMM YYYY'): string {
  return dayjs(iso).tz(DHAKA_TZ).format(fmt);
}

export function formatDateTime(iso: string | Date, fmt = 'DD MMM YYYY, HH:mm'): string {
  return dayjs(iso).tz(DHAKA_TZ).format(fmt);
}

export function formatRelative(iso: string | Date): string {
  return dayjs(iso).tz(DHAKA_TZ).fromNow();
}

export { dayjs };
